<template>
  <div id="app" ref="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        counter: null
      }
    },
    methods: {
      sendHeight () {
        const height = this.$refs.app.offsetHeight
        window.parent.postMessage({height: height}, '*')
        this.counter = setTimeout(() => {
          this.sendHeight()
        }, 200)
      }
    },
    mounted () {
      if (window.parent) {
        this.sendHeight()
      }
    },
    beforeDestroy () {
      clearTimeout(this.counter)
    }
  }
</script>

<style>

</style>
